import { StandardProps } from "@/types/types";
import styles from "./TotalItems.module.scss";

export function TotalItems({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const { results } = productListingData;

  const numItemsString =
    results === 1 ? "1 item" : `${results.toLocaleString("en")} items`;

  return (
    <div
      data-component="TotalItems"
      className={styles["total-items"]}
      data-testid="total-items"
    >
      {numItemsString}
    </div>
  );
}
